module.exports = __webpack_public_path__ + "img/Logo-linknau-new.a367c4fb.svg";